<template>
  <div class="pagePaypassword">
    <XR-head titleText="支付密码设置" :rightShow="false" ref="headObj"></XR-head>
    <div>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="新密码" type="password" helpText="请输入您的新密码" v-model="initInfo.NewPassword" labelFloat fullWidth />
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="确认密码" type="password" helpText="请再次输入您的新密码" labelFloat fullWidth v-model="initInfo.ConfrimNewPassword" />
        </mu-col>
      </mu-row>    
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="btn-div">          
          <mu-raised-button :label="submitText" class="submit" primary fullWidth @click="submit()" />
        </mu-col>
      </mu-row>  
    </div>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import md5 from 'js-md5'
export default {
  data () {
    return {
      submitText: '确 定',
      isRequest: false,
      initInfo : {
        NewPassword:'',
        ConfrimNewPassword:'',
        redirect_url: this.$route.query.redirect_url,
      }
    }
  },
  methods: {
    submit: function(){
	  if (this.initInfo.NewPassword == ""){
	    this.$refs.XRtoast.failed("新支付密码不能为空", true)
		return
	  }
	  if (this.initInfo.ConfrimNewPassword == ""){
	    this.$refs.XRtoast.failed("确认密码不能为空", true)
		return
	  }
	  if (this.initInfo.NewPassword != this.initInfo.ConfrimNewPassword){
	    this.$refs.XRtoast.failed("两次输入的密码不一致", true)
		return
	  }
      var ths = this;
      if(!ths.isRequest){
        ths.isRequest = true 
        ths.submitText = '正在提交...'
        this.$post(
          "/Shop/UserServer/InitPayPassword", JSON.stringify(this.initInfo)
        ).then(function(res) {
          ths.isRequest = false
          ths.submitText = '确 定'
          if(res.IsSuccess){
            ths.$refs.XRtoast.success(res.Msg, true)
          }else{
            ths.initInfo.NewPassword = ''
            ths.initInfo.ConfrimNewPassword = ''
            ths.$refs.XRtoast.failed(res.Msg, true)
          }
        });
      }
    },
    goBack(){      
      if(this.redirect_url){
        this.$router.push(this.redirect_url)
      }else{
        this.$router.goBack()
      }
    }
  }
}
</script>
<style>
body .pagePaypassword{
  background: white;
}
.pagePaypassword .rowFiled{
  padding: 0 5%;
}
.pagePaypassword .forgetBtn {
  float: right;
}

.pagePaypassword .btn-div {
  padding: 40px 5% 30px;
}
.pagePaypassword .submit {
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/paypassword.vue